import React from 'react';
import PropTypes from 'prop-types';

const ProgressBarView = ({ label, percentage, hasLine, hide }) =>
  !hide && (
    <div className="adv-workflow-progress-bar">
      {hasLine ? (
        <div className="adv-workflow-progress-bar-track-line" />
      ) : (
        <div className="adv-workflow-progress-bar-track">
          <div
            className="adv-workflow-progress-bar-track-fill"
            style={{ transform: `translateX(${percentage - 100}%)` }}
          />
        </div>
      )}
      <div aria-live="assertive" role="alert" className="adv-workflow-progress-bar-label">
        {label}
      </div>
    </div>
  );

ProgressBarView.propTypes = {
  hide: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  hasLine: PropTypes.bool.isRequired,
};

export default ProgressBarView;
